import TakeoverBanner from './takeover-dialog-content';

export default TakeoverBanner;
